import "./Components/scss/main.scss";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./Screens/Home";
import Samples from "./Screens/Samples";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="samples" element={<Samples />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
